import type { NodeProps } from '@xyflow/react'
import * as Flags from 'country-flag-icons/react/3x2'
import { BaseNode } from 'uikit/graphs/default'
import { BusinessEntityTypes, type BusinessEntityType, type NetworkNodeData } from '../types'
import { getNodeTypeConfig } from '../constants'
import placeholderIcon from '../../assets/nodes/image-placeholder.svg'
import styles from './nodes.module.scss'

interface NodeIconProps {
  nodeType: BusinessEntityType
  countryCode?: string
}

function NodeIcon({ nodeType, countryCode }: NodeIconProps) {
  const isLocationNode = nodeType === BusinessEntityTypes.LOCATION

  if (isLocationNode && countryCode) {
    const FlagComponent = Flags[countryCode.toUpperCase() as keyof typeof Flags]
    if (FlagComponent) {
      return (
        <div className={styles.flagContainer}>
          <FlagComponent className={styles.flagIcon} />
        </div>
      )
    }
  }

  const icon = getNodeTypeConfig(nodeType).icon ?? placeholderIcon
  return <img src={icon} alt={nodeType} className={styles.nodeIcon} />
}

export function ContactInfoNode({ data, selected }: NodeProps) {
  const nodeData = data as NetworkNodeData
  const { nodeType, metadata } = nodeData

  return (
    <BaseNode
      selected={selected}
      nodeData={nodeData}
      isConnectable={nodeData.isConnectable}
      disabledClassName={styles.disabledGrayscaleBright}
      labelClassName={styles.labelMaxWidth}
    >
      <NodeIcon nodeType={nodeType} countryCode={metadata?.country_code} />
    </BaseNode>
  )
}
